.wizard {
  min-height: 100%;
}

.page {
  flex: 1;
}

/* stays in view while a long page of pictures scrolls */
.footer {
  position: sticky;
  bottom: calc(-1 * var(--ant-padding-lg));
  padding: var(--ant-padding) 0;
  border-top: var(--ant-line-width) solid var(--ant-color-border-secondary);
  background: var(--ant-color-bg-elevated);
}
